import { useMutation, useQueryClient } from '@tanstack/react-query';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import { deleteWorkspace } from '../../../api/workspaces/deleteWorkspace';

export function useDeleteWorkspaceMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteWorkspace,
    onSuccess: (_data, { workspaceId }) => {
      queryClient.removeQueries(workspaceKeys.byId(workspaceId));
      queryClient.invalidateQueries(workspaceKeys.list());
    },
  });
}
